/**
 * DevExtreme (esm/core/component_registrator_callbacks.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import MemorizedCallbacks from "./memorized_callbacks";
export default new MemorizedCallbacks;
